<app-carrusel-imgs></app-carrusel-imgs>
<app-carrusel-iconos></app-carrusel-iconos>
<app-news></app-news>